export default {"src":"/_next/static/media/intuity_logo.8970d0e3.svg","height":250,"width":725,"blurWidth":0,"blurHeight":0};